import * as React from "react";
import * as ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";

import { messages } from "../translations";
import { getLanguageCode } from "../shared/utils";
import { Keyboard } from "./components";

import "./index.scss";

interface AppConfiguration {
    language?: string;
}

const defaultConfiguration: AppConfiguration = {};

declare global {
    interface Window {
        renderKeyboard: (inputElementId: string, language: string) => void;
    }
}

function createKeyboardContainer(): HTMLDivElement {
    const output = document.createElement("div");
    output.id = "keyboard-container";
    return output;
}

window.renderKeyboard = (inputElementId: string, language: string): void => {
    const appConfig = Object.assign({}, defaultConfiguration, { language });
    const langCode = getLanguageCode(appConfig.language);
    const container =
        document.getElementById("keyboard-container") ||
        document.body.appendChild(createKeyboardContainer());

    const unmountRef = () => ReactDOM.unmountComponentAtNode(container);

    unmountRef();

    ReactDOM.render(
        <IntlProvider locale={langCode} messages={messages[langCode]}>
            <Keyboard inputElementId={inputElementId} onClose={unmountRef} />
        </IntlProvider>,
        container
    );
};
